import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/ZipEntryBar")
);

const SearchBarEditConfig = {
  emptyLabel: "SearchBar",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const SearchBar = (props) => {
  const makeParentSticky = (node) => {
    if (!props.isSticky || !node) {
      return;
    }
    if (node.parentElement) {
      node.parentElement.style.position = "sticky";
      node.parentElement.style.bottom = 0;
    }
  };
  return (
    <div ref={makeParentSticky}>
      <Component {...props} />
    </div>
  );
};

export default withAemIntegration("lexus/components/search-bar")(
  SearchBar,
  SearchBarEditConfig
);
